import React, { useEffect, useState } from 'react';
import styles from 'src/Css/custom/Ann.module.css';
import { api } from 'src/Basic/ApiFetch';
import { getGlobalServerConfig } from 'src/Route/RootMiddleware';

const AnnnounceWindow = (props) => {
    const { isOpen, closeWindow } = props;
    const [data, setData] = useState(null);

    /**
     * 取得公告資料
     */
    const getAnnouncementDisplay = async () => {
        let response = await api.Get(getGlobalServerConfig().backEndUrl.get() + "Announcement/Display");
        if (response && response.ok) {
            const result = await response.json();
            setData(result);
        }
    }

    useEffect(() => {
        if (isOpen) {
            getAnnouncementDisplay();
        }
    }, [isOpen])

    return (
        <>
            {isOpen && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalHeader}>
                        <span className={styles.modalTitle}>系統公告</span>
                        <button className={styles.closeButton} onClick={() => { closeWindow() }}>×</button>
                    </div>
                    <div className={styles.modalContent}>

                        <div className={styles.modalBody}>
                            {data ? (
                                data.map((item) => (
                                    <div key={item.SID} className={styles.modalItem}>
                                        <p>{item.COMMENT}</p>
                                        <span className={styles.date}>{item.EFFECTIVE_TWDATE}</span>
                                    </div>
                                ))
                            ) : (
                                <div>公告載入中...</div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AnnnounceWindow;
